import MuiTypography from '@mui/material/Typography';
import { TypographyProps } from '@mui/material/Typography';

export function Typography<C extends React.ElementType>(
  props: TypographyProps<C, { component?: C }>
) {
  const { color, ...extraProps } = props;

  const regularColors = {
    primary: 'primary.text',
    secondary: 'secondary.text',
    warning: 'warning.text',
    error: 'error.text',
    info: 'info.text',
    success: 'success.text',
    textDisabled: 'text.disabled',
  };

  const specialColor = color && regularColors[color];

  return <MuiTypography color={specialColor || color} {...extraProps} />;
}

export type { TypographyProps };
